import { OrdersBasketForm } from 'components/Forms/OrdersBasket/OrdersBasketForm';
import { EmptyState } from 'components/shared/EmptyState/EmptyState';
import { FC } from 'react';

import { connectOrdersBasketBodyComponent } from './OrdersBasketBody.connect';
import type { OrdersBasketBodyProps } from './OrdersBasketBody.models';

export const OrdersBasketBodyComponent: FC<OrdersBasketBodyProps> = ({
  formIds,
  productSubType,
  productType,
  nbOfFields,
  isVisible,
}) => {
  return (
    <tbody>
      {formIds.length === 0 ? (
        <tr>
          <td colSpan={nbOfFields}>
            <EmptyState prefix="ordersBasket" e2e="orders-basket" />
          </td>
        </tr>
      ) : (
        formIds.map(formId => (
          <OrdersBasketForm
            isVisible={isVisible}
            key={formId}
            formId={formId}
            productSubType={productSubType}
            productType={productType}
          />
        ))
      )}
    </tbody>
  );
};

export const OrdersBasketBody = connectOrdersBasketBodyComponent(OrdersBasketBodyComponent);
